<template>
<el-dialog :visible="visible" :fullscreen="true" :close-on-click-modal="true" :show-close="false" :close-on-press-escape="false" @open="onOpened" @closed="onClosed" custom-class="dialog_padding_body">
    <div slot="title" class="dialog-title d-flex mb-3">
        <div class="header-main-title">
            <h1 v-if="dataPayroll.data==null" v-text="'Registrar ' + title">Titulo</h1>
            <div v-else class="d-flex">
                <el-avatar shape="square" :size="'large'" :src="photo" class="mr-3"></el-avatar>
                <div class="sub-title">
                    <h4 class="m-0">{{dataPayroll.person.firstname}}</h4>
                    <h5 class="m-0">{{dataPayroll.person.lastname + ' ' + dataPayroll.person.surname}}</h5>
                </div>
            </div>
        </div>
        <el-alert title="Campos marcados con (*) son campos obligatorios" type="warning" show-icon class="ml-auto mr-4 w-auto" :closable="false">
        </el-alert>
        <div class="btn btn-outline-danger" @click="onClose">Cancelar</div>
        <!--<el-button size="small" class="ml-auto" @click.native="onClose">Cancelar</el-button>-->
    </div>
    <el-tabs v-model="activeTab" tab-position="left" :style="{height: altura + 'px', overflowY: 'auto'}" @tab-click="tabClick" :stretch="true">
        <el-tab-pane name="tab1">
            <div class="d-flex align-items-center p-3 text-left" slot="label" style="line-height:1.4">
                <div class="wizard-icon mr-3">
                    <span class="svg-icon svg-icon-2x">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-person-lines-fill" viewBox="0 0 16 16">
                            <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z" />
                        </svg>
                    </span>
                </div>
                <div class="wizard-label">
                    <h4 class="wizard-title m-0"> Datos Personales </h4>
                    <div class="wizard-desc font-size-sm"> Complete su información personal</div>
                </div>
            </div>
            <w1 v-if="isTabPerson" :info="payroll" :record_type="record_type" :addedit="disabled" @onAddEdit="onAddEdit"></w1>
        </el-tab-pane>

        <el-tab-pane name="tab2" :disabled="disabled">
            <div class="d-flex align-items-center p-3 text-left" slot="label" style="line-height:1.4">
                <div class="wizard-icon mr-3">
                    <span class="svg-icon svg-icon-2x">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-bookmark-star-fill" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zM8.16 4.1a.178.178 0 0 0-.32 0l-.634 1.285a.178.178 0 0 1-.134.098l-1.42.206a.178.178 0 0 0-.098.303L6.58 6.993c.042.041.061.1.051.158L6.39 8.565a.178.178 0 0 0 .258.187l1.27-.668a.178.178 0 0 1 .165 0l1.27.668a.178.178 0 0 0 .257-.187L9.368 7.15a.178.178 0 0 1 .05-.158l1.028-1.001a.178.178 0 0 0-.098-.303l-1.42-.206a.178.178 0 0 1-.134-.098L8.16 4.1z" />
                        </svg>
                    </span>
                </div>
                <div class="wizard-label">
                    <h4 class="wizard-title m-0"> Datos Deportivos </h4>
                    <div class="wizard-desc font-size-sm"> Logros obtenidos </div>
                </div>
            </div>
            <w2 :sports_data="sports_data"></w2>
        </el-tab-pane>

        <el-tab-pane name="tab3" :disabled="disabled">
            <div class="d-flex align-items-center p-3 text-left" slot="label" style="line-height:1.4">
                <div class="wizard-icon mr-3">
                    <span class="svg-icon svg-icon-2x">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-trophy-fill" viewBox="0 0 16 16">
                            <path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935z" />
                        </svg>
                    </span>
                </div>
                <div class="wizard-label">
                    <h4 class="wizard-title m-0"> Premios </h4>
                    <div class="wizard-desc font-size-sm"> Condecoraciones obtenidas </div>
                </div>
            </div>
            <w3 :decorations="decorations"></w3>
        </el-tab-pane>

        <el-tab-pane name="tab4" :disabled="disabled">
            <div class="d-flex align-items-center p-3 text-left" slot="label" style="line-height:1.4">
                <div class="wizard-icon mr-3">
                    <span class="svg-icon svg-icon-primary svg-icon-2x">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-flag-fill" viewBox="0 0 16 16">
                            <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001" />
                        </svg>
                    </span>
                </div>

                <div class="wizard-label">
                    <h4 class="wizard-title m-0"> Sanciones </h4>
                    <div class="wizard-desc font-size-sm"> Faltas cometidas </div>
                </div>
            </div>
            <w4 :sanctions="sanctions"></w4>
        </el-tab-pane>

        <el-tab-pane name="tab5" :disabled="disabled">
            <div class="d-flex align-items-center p-3 text-left" slot="label" style="line-height:1.4">
                <div class="wizard-icon mr-3">
                    <span class="svg-icon svg-icon-2x">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-sunglasses" viewBox="0 0 16 16">
                            <path d="M3 5a2 2 0 0 0-2 2v.5H.5a.5.5 0 0 0 0 1H1V9a2 2 0 0 0 2 2h1a3 3 0 0 0 3-3 1 1 0 1 1 2 0 3 3 0 0 0 3 3h1a2 2 0 0 0 2-2v-.5h.5a.5.5 0 0 0 0-1H15V7a2 2 0 0 0-2-2h-2a2 2 0 0 0-1.888 1.338A1.99 1.99 0 0 0 8 6a1.99 1.99 0 0 0-1.112.338A2 2 0 0 0 5 5H3zm0 1h.941c.264 0 .348.356.112.474l-.457.228a2 2 0 0 0-.894.894l-.228.457C2.356 8.289 2 8.205 2 7.94V7a1 1 0 0 1 1-1z" />
                        </svg>
                    </span>
                </div>
                <div class="wizard-label">
                    <h4 class="wizard-title m-0"> Vestimenta </h4>
                    <div class="wizard-desc font-size-sm"> Tamaño de polo, busos, shorts </div>
                </div>
            </div>
            <w5 :outfit="outfit"></w5>
        </el-tab-pane>

        <el-tab-pane name="tab6" :disabled="disabled">
            <div class="d-flex align-items-center p-3 text-left" slot="label" style="line-height:1.4">
                <div class="wizard-icon mr-3">
                    <span class="svg-icon svg-icon-2x">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-briefcase-fill" viewBox="0 0 16 16">
                            <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v1.384l7.614 2.03a1.5 1.5 0 0 0 .772 0L16 5.884V4.5A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5z" />
                            <path d="M0 12.5A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5V6.85L8.129 8.947a.5.5 0 0 1-.258 0L0 6.85v5.65z" />
                        </svg>
                    </span>
                </div>
                <div class="wizard-label">
                    <h4 class="wizard-title m-0"> Estudios </h4>
                    <div class="wizard-desc font-size-sm"> Información académica </div>
                </div>
            </div>
            <w6 :studies="studies"></w6>
        </el-tab-pane>

        <el-tab-pane name="tab7" :disabled="disabled">
            <div class="d-flex align-items-center p-3 text-left" slot="label" style="line-height:1.4">
                <div class="wizard-icon mr-3">
                    <span class="svg-icon svg-icon-2x">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-mortarboard-fill" viewBox="0 0 16 16">
                            <path d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917l-7.5-3.5Z" />
                            <path d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466 4.176 9.032Z" />
                        </svg>
                    </span>
                </div>
                <div class="wizard-label">
                    <h4 class="wizard-title m-0"> Capacitaciones </h4>
                    <div class="wizard-desc font-size-sm"> Especializaciones diversas </div>
                </div>
            </div>
            <w7 :coaching="coaching"></w7>
        </el-tab-pane>
    </el-tabs>

</el-dialog>
</template>

<script>
import w1 from "./w_personal_data"
import w2 from "./w_sports_data"
import w3 from "./w_decorations"
import w4 from "./w_sanctions"
import w5 from "./w_outfit"
import w6 from "./w_studies"
import w7 from "./w_coaching"

export default {
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
        title: {
            type: String,
            required: true,
            default: "",
        },
        payroll: {
            type: Object,
            required: true,
            default: {}
        },
        record_type: {
            type: String,
            required: false,
            default: ''
        }
    },
    components: {
        w1,
        w2,
        w3,
        w4,
        w5,
        w6,
        w7
    },
    data: () => ({
        dataPayroll: {},
        altura: 0,
        disabled: true,
        activeTab: 'tab1',
        isTabPerson: false,
        sports_data: [],
        decorations: [],
        sanctions: [],
        outfit: [],
        studies: [],
        coaching: [],
        photo: null
    }),
    computed: {

    },
    methods: {
        onOpened() {
            //console.log('melaaa')
            //console.log(this.record_type)
            this.activeTab = 'tab1'
            this.isTabPerson = true
            document.body.classList.add('el-popup-parent--hiddens')
            this.dataPayroll = this.payroll
            this.disabled = (this.dataPayroll.data == null) ? true : false
            if(this.dataPayroll.photo)
                this.photo = this.dataPayroll.photo
            this.altura = screen.height - 192;
        },
        onClose() {
            this.$emit("update:visible", false);
            document.body.classList.remove('el-popup-parent--hiddens')
        },
        onClosed() {
            this.photo = null
            this.isTabPerson = false
            this.$emit("loadPayroll");
            console.log('cerrado')
        },
        onAddEdit(data) {
            console.log(data)
            this.disabled = false
            this.dataPayroll.person = data.person
            this.dataPayroll.data = data.payroll
            return this.$alert(data.message, 'Alerta', {
                type: 'success',
                dangerouslyUseHTMLString: true
            })
        },
        tabClick() {
            switch (this.activeTab) {
                case 'tab1': //datos personales
                    break;

                case 'tab2': //datos deportivos
                    console.log(this.dataPayroll.data)
                    break;

                case 'tab3': //premios
                    console.log(this.dataPayroll.data)
                    break;

                case 'tab4': //sanciones
                    console.log(this.dataPayroll.data)
                    //this.onSanctions()
                    break;

                case 'tab5': //vestimenta
                    break;

                case 'tab6': //estudios
                    break;

                case 'tab7': //capacitaciones
                    break;

                default:
                    console.log('no hay proceso tab')
                    break;
            }
        },
        onSanctions() {
            console.log('listar sanciones')
        }

    },
    created() {}

}
</script>

<!--
disabled: deshabilitado?: true ->si | false: no
addedit: true-> add | : false -> editar
-->

<style>
/*.ps {
  height: 200px;
}*/
</style>
